export default __webpack_public_path__ + "37fae6739c7b9335f88c9801109a7d92.png";